const ITEMS = [
    "Lagan · 14 Nov",
    "Ghritpaan · 16 Nov",
    "Vinayak · 20 Nov",
    "Haldi · 21 Nov",
    "Mehandi · 22 Nov",
    "Badi Bandoli · 23 Nov",
    "Baraat · 24 Nov",
    "Preetibhoj · 24 Nov",
    "Panigrahana · 24 Nov",
    "Vijju ♡ Dileep",
];

export default function Marquee() {
    const row = (key, hidden) => (
        <div className="marquee-track" key={key} aria-hidden={hidden}>
            {ITEMS.map((item, i) => (
                <span key={`${key}-${i}`} className="flex items-center gap-12">
                    <span className="font-display text-lg italic sm:text-xl" style={{ color: "var(--wine)" }}>
                        {item}
                    </span>
                    <span style={{ color: "var(--gold)" }}>✦</span>
                </span>
            ))}
        </div>
    );

    return (
        <div
            data-testid="ceremony-marquee"
            className="marquee border-y py-5"
            style={{ borderColor: "rgba(212,175,55,0.35)", background: "var(--blush)" }}
        >
            <div className="flex">
                {row("a", false)}
                {row("b", true)}
            </div>
        </div>
    );
}
